"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KnowledgeSearchManager = void 0;
/**
 * Static helper class for managing knowledge search, filtering, and debouncing
 */
class KnowledgeSearchManager {
    /**
     * Create debounced search function
     */
    static createDebouncedSearch(key, callback, delay = 300) {
        // Clear existing timeout for this key
        const existingTimeout = this.searchTimeouts.get(key);
        if (existingTimeout) {
            clearTimeout(existingTimeout);
        }
        // Set new timeout
        const timeout = setTimeout(callback, delay);
        this.searchTimeouts.set(key, timeout);
    }
    /**
     * Clear search timeout for specific key
     */
    static clearSearchTimeout(key) {
        const timeout = this.searchTimeouts.get(key);
        if (timeout) {
            clearTimeout(timeout);
            this.searchTimeouts.delete(key);
        }
    }
    /**
     * Clear all search timeouts
     */
    static clearAllTimeouts() {
        for (const [key, timeout] of this.searchTimeouts.entries()) {
            clearTimeout(timeout);
        }
        this.searchTimeouts.clear();
    }
    /**
     * Filter knowledge entries based on search term and selected IDs
     */
    static filterKnowledgeEntries(knowledgeEntries, selectedKnowledge, selectedIds) {
        let availableEntries = [];
        availableEntries = knowledgeEntries.filter(k => !selectedIds.includes(k.id.toString()));
        const matchingSelectedEntries = selectedKnowledge.filter(k => {
            return !selectedIds.includes(k.id.toString());
        });
        // Combine and remove duplicates
        const combinedEntries = [...availableEntries, ...matchingSelectedEntries];
        console.log({ combinedEntries });
        return combinedEntries.filter((entry, index, self) => index === self.findIndex(e => e.id === entry.id));
    }
    /**
     * Filter projects based on search term and selected projects
     */
    static filterProjects(projects, selectedProjects) {
        const selectedProjectIds = selectedProjects.map(p => p.id);
        return projects.filter(p => !selectedProjectIds.includes(p.id));
    }
    /**
     * Check if knowledge entry matches search term
     */
    static matchesSearchTerm(knowledge, searchTermLower) {
        var _a, _b;
        return (knowledge.title.toLowerCase().includes(searchTermLower) ||
            ((_a = knowledge.description) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchTermLower)) ||
            ((_b = knowledge.tags) === null || _b === void 0 ? void 0 : _b.some(tag => tag.toLowerCase().includes(searchTermLower))));
    }
    /**
     * Validate and clean search term
     */
    static cleanSearchTerm(term) {
        return (term === null || term === void 0 ? void 0 : term.trim()) || '';
    }
    /**
     * Check if search term is valid (not empty, meets minimum length, etc.)
     */
    static isValidSearchTerm(term, minLength = 0) {
        const cleaned = this.cleanSearchTerm(term);
        return cleaned.length >= minLength;
    }
}
exports.KnowledgeSearchManager = KnowledgeSearchManager;
KnowledgeSearchManager.searchTimeouts = new Map();
